import * as React from 'react';
import { SVGProps } from 'react';

const SvgFeedback = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 130 89'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect
      y={36.348}
      width={36.348}
      height={72.696}
      rx={8}
      transform='rotate(-90 0 36.348)'
      fill='#0F2EFF'
    />
    <path
      d='M80.296 11.11h4.678a4.678 4.678 0 1 0-4.678-4.678v4.678Z'
      fill='#ECECEC'
    />
    <path
      d='M114.212 60.815h6.432a6.432 6.432 0 0 0 6.432-6.432 6.431 6.431 0 1 0-12.864 0v6.432Z'
      fill='#0F2EFF'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M68.31 23.867h-1.254v-1.253h-.627v1.253h-1.253v.627h1.253v1.253h.627v-1.253h1.253v-.627Zm-.684 3.134a3.76 3.76 0 1 1-3.703-3.134v-.627a4.387 4.387 0 1 0 4.386 4.387c-.002-.21-.019-.419-.05-.626h-.633Zm-5.897-.157c0-.433.35-.783.784-.783a.777.777 0 0 1 .783.783.783.783 0 0 1-1.567 0Zm3.604-.783a.783.783 0 1 0 .783.783.777.777 0 0 0-.783-.783Zm-1.41 4.072a2.548 2.548 0 0 1-2.194-1.252h4.387a2.548 2.548 0 0 1-2.193 1.252Z'
      fill='#fff'
    />
    <rect
      x={16.921}
      y={9.453}
      width={2.507}
      height={47.629}
      rx={1.253}
      transform='rotate(-90 16.92 9.453)'
      fill='#fff'
    />
    <rect
      x={16.921}
      y={16.974}
      width={2.507}
      height={23.814}
      rx={1.253}
      transform='rotate(-90 16.92 16.974)'
      fill='#fff'
    />
    <rect
      x={5.014}
      y={11.96}
      width={7.52}
      height={7.52}
      rx={3.76}
      transform='rotate(-90 5.014 11.96)'
      fill='#FACB02'
    />
    <path
      fill='#0F2EFF'
      d='m48.069 35.588 6.647-6.647 6.647 6.647-6.647 6.646z'
    />
    <rect
      x={56.187}
      y={84.494}
      width={24.265}
      height={48.529}
      rx={8.537}
      transform='rotate(-90 56.187 84.494)'
      fill='#ECECEC'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M101.182 75.385a.236.236 0 0 0-.248-.054l-5.2 1.89a.236.236 0 0 0 0 .442l2.269.908.907 2.269a.236.236 0 0 0 .213.149.236.236 0 0 0 .218-.156l1.89-5.2a.236.236 0 0 0-.049-.248Zm-2.059 4.706-.66-1.655 1.133-1.132-.334-.333-1.141 1.141-1.645-.668 4.143-1.496-1.496 4.143Z'
      fill='#fff'
    />
    <rect
      x={67.483}
      y={67.199}
      width={1.673}
      height={31.795}
      rx={0.837}
      transform='rotate(-90 67.483 67.2)'
      fill='#fff'
    />
    <rect
      x={67.483}
      y={72.219}
      width={1.673}
      height={15.898}
      rx={0.837}
      transform='rotate(-90 67.483 72.22)'
      fill='#fff'
    />
    <rect
      x={59.534}
      y={68.872}
      width={5.02}
      height={5.02}
      rx={2.51}
      transform='rotate(-90 59.534 68.872)'
      fill='#0F2EFF'
    />
    <path
      fill='#ECECEC'
      d='m88.276 84.002 4.437-4.437 4.437 4.437-4.437 4.437z'
    />
    <path fill='#FFCB00' d='m117.998 35.465 3.239-3.24 3.24 3.24-3.24 3.24z' />
    <rect
      x={94.573}
      y={36.519}
      width={17.713}
      height={35.426}
      rx={6.24}
      transform='rotate(-90 94.573 36.52)'
      fill='#FFCB00'
    />
    <rect
      x={102.819}
      y={23.315}
      width={1.222}
      height={23.21}
      rx={0.611}
      transform='rotate(-90 102.819 23.315)'
      fill='#fff'
    />
    <rect
      x={102.819}
      y={26.98}
      width={1.222}
      height={11.605}
      rx={0.611}
      transform='rotate(-90 102.819 26.98)'
      fill='#fff'
    />
    <rect
      x={96.678}
      y={24.536}
      width={3.665}
      height={3.665}
      rx={1.832}
      transform='rotate(-90 96.678 24.536)'
      fill='#fff'
    />
    <rect
      x={112.504}
      y={30.485}
      width={14.329}
      height={2.269}
      rx={1.134}
      stroke='#fff'
      strokeWidth={1.5}
    />
    <path
      d='M15.204 74.264h11.694c6.46 0 11.695-5.237 11.695-11.694 0-6.46-5.236-11.696-11.695-11.696-6.458 0-11.694 5.236-11.694 11.694v11.696Z'
      fill='#FFCB00'
    />
  </svg>
);

export default SvgFeedback;
